import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './EditConfigButton.scss';

export interface Props {
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  iconRef?: React.RefCallback<any>;
}

const EditConfigButton: React.FC<Props> = ({
  className,
  onClick,
  disabled,
  iconRef,
}) => {
  const { t } = useTranslation();
  return (
    <BiButton
      onClick={onClick}
      disabled={disabled}
      className={classnames(
        s['edit-button'],
        disabled && s['disabled'],
        className
      )}
      data-role="edit-control"
      biData={{
        evid: BiEventType.EDIT_WIDGET_CLICK,
      }}
    >
      <EditIcon
        size={IconSize.MEDIUM}
        className={s['icon']}
        condensed
        containerRef={iconRef}
      />
      <span className={s['edit-button-text']}>{t!('common.edit')}</span>
    </BiButton>
  );
};

EditConfigButton.displayName = 'EditConfigButton';

export default EditConfigButton;
